import React, {Component} from "react";
import axios from "axios";
import './../../node_modules/izitoast/dist/css/iziToast.min.css';
import {getHeader, sendSubscribeEmail} from "../config";
import {withTranslate} from "react-redux-multilingual"
import DownLoadApp from "./DownloadApp";
import {showToast} from "../helpers/magic";


class Subscribe extends Component {
    state = {
        email: null,
        errors: null
    };


    handleEmailChange = (e) => {
        const email = e.target.value;
        this.setState({
            email: email
        })
    };

    handleFormSubmission = (e) => {
        // prevent default behavior
        e.preventDefault();
        console.log("handling form");
        // send data to server
        axios.post(sendSubscribeEmail, this.state, {headers: getHeader()}).then(res => {
            if (res.data.Error.status === true) {
                // Reset errors
                this.resetErrors();
                // show success toast
                showToast("You have subscribed", "green");

                document.getElementById("subscribe-form").reset();

                this.setState({
                    email: null

                });
                // show success message
            } else {
                const errors = res.data.Error.validation;
                this.handleRecordErrors(errors);
                console.log(errors);
            }
        }).catch(error => {

        })
    };


    handleErrors(field) {
        if (this.state.errors) {
            return this.state.errors[field]
        }
        return false
    }

    handleRecordErrors = (errors) => {
        this.setState({
            errors: errors
        });
    };

    resetErrors = () => {
        this.setState({
            errors: null
        })
    }

    render() {
        return (
            <section id="subscribe" className="subscribe ftco-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            {/* <div className="ftco-section-parallax shadow-4d">
                        <div className="parallax-img  align-items-center">
                            <div className="subsribe-section  heading-section heading-section-white ftco-animate">
                                <h2 className="text-center header-main-color">{this.props.translate("subscribe")} </h2>
                                <p className="text-center white">{this.props.translate("subscribe_Text")}</p>
                            </div>
                            <div className="row  justify-content-center mt-5">
                                <div className="col-md-8">
                                    <form action="#" onSubmit={this.handleFormSubmission}
                                          className="subscribe-form"
                                          id="subscribe-form">
                                        <div className="form-group d-flex">
                                            <input id="email" type="text"
                                                   className="form-control align-right-rtl"
                                                   placeholder={this.props.translate("enter_your_email_address")}
                                                   onChange={this.handleEmailChange}/>

                                            <input type="submit" value={this.props.translate("subscribe")}
                                                   className="submit px-3"/>
                                        </div>
                                        {
                                            (this.handleErrors("email") ? <span
                                                className="error-msg styled-error-msg">{this.handleErrors("email")}</span> : "")
                                        }
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>*/}

                            <div className="flex-container rounded-corners">

                                <div className="subscribe-flex-half form">
                                    <h2>{this.props.translate("subscribe")} </h2>
                                    <p className="subscribe-text">{this.props.translate("subscribe_Text")}</p>


                                    <ul className="no-style">
                                        <li>
                                            <form action="#" onSubmit={this.handleFormSubmission}
                                                  className="subscribe-form"
                                                  id="subscribe-form">
                                                <div className="form-group d-flex">
                                                    <input id="email" type="text"
                                                           className="form-control align-right-rtl"
                                                           placeholder={this.props.translate("enter_your_email_address")}
                                                           onChange={this.handleEmailChange}/>

                                                    <input type="submit" value={this.props.translate("subscribe")}
                                                           className="submit px-3"/>
                                                    {
                                                        (this.handleErrors("email") ? <span
                                                            className="error-msg styled-error-msg">{this.handleErrors("email")}</span> : "")
                                                    }
                                                </div>
                                            </form>
                                        </li>
                                        <li className="store-download">
                                            <DownLoadApp/>
                                        </li>

                                    </ul>
                                </div>
                                <div className="subscribe-flex-half image"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}


export default withTranslate(Subscribe);


/// References ////////
//// https://www.npmjs.com/package/izitoast/v/1.0.2




